import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as CreateSalesforceTaskActionMetadataKeys from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionMetadataKeys';
export default class CreateSalesforceTaskActionMetadata extends Record({
  [CreateSalesforceTaskActionMetadataKeys.ACTION_TYPE]: ActionTypes.CREATE_SALESFORCE_TASK,
  [CreateSalesforceTaskActionMetadataKeys.STATUS]: null,
  [CreateSalesforceTaskActionMetadataKeys.EMAIL]: null,
  [CreateSalesforceTaskActionMetadataKeys.SUBJECT]: null,
  [CreateSalesforceTaskActionMetadataKeys.COMMENTS]: null,
  [CreateSalesforceTaskActionMetadataKeys.PRIORITY]: null,
  [CreateSalesforceTaskActionMetadataKeys.DAYS_FROM]: null
}, 'CreateSalesforceTaskActionMetadata') {}